import { makeAutoObservable, runInAction } from "mobx";
import { access_key, baseUrl } from "./main";
export default class VacanciesStore {
  vacancies = [];
  allVacanciesCount = "";
  vacanciesPerPage = 6;
  page = 1;

  selectedVacancy;

  positions = "";
  cities = "";
  statuses = "";
  events = "";
  currentVacancies = [];

  vacancies_for_candidate = [];

  vacanciesObj = null;

  error = false;
  isLoading = false;

  constructor(instance) {
    this.rootStore = instance;
    makeAutoObservable(this, {}, { deep: true });
  }

  getVacanciesData = async (vacanciesPerPage) => {
    this.isLoading = true;
    this.vacancies = [];

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", 1);
    bodyData.append(
      "on_page",
      vacanciesPerPage ? vacanciesPerPage : this.vacanciesPerPage
    );
    bodyData.append("order", "date_create");
    bodyData.append("ordered", "DESC");

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies`,
      {
        method: "POST",
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.isLoading = false;
          this.error = true;
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["records"] !== "-1") {
            this.vacancies = response["records"];
            this.allVacanciesCount = response["count_all"];
            this.positions = response["positions"];
            this.cities = response["cities"];
            this.statuses = response["vacances_statuses"];
            this.events = response["calendar_events"];

            this.vacanciesObj = {};

            for (const one of response["records"]) {
              this.vacanciesObj[one.id] = one;
            }
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  showMoreVacancies = async () => {
    this.isLoading = true;
    this.page = this.page + 1;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", this.page);
    bodyData.append("on_page", this.vacanciesPerPage);
    bodyData.append("order", "date_create");
    bodyData.append("ordered", "DESC");

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies`,
      {
        method: "POST",
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["records"] !== "-1") {
            this.vacancies = [...this.vacancies, ...response["records"]];
            this.allNewsCount = response["count_all"];
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  getOneVacancy = async (id) => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", 1);
    bodyData.append("on_page", 1000);
    bodyData.append("order", "date_create");
    bodyData.append("ordered", "DESC");

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies`,
      {
        method: "POST",
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["records"] !== "-1") {
            this.selectedVacancy = response["records"].find(
              (item) => item.id === id
            );

            this.allVacanciesCount = response["count_all"];
            this.positions = response["positions"];
            this.cities = response["cities"];
            this.statuses = response["vacances_statuses"];
            this.events = response["calendar_events"];
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  getApplicationsForVacancy = async (data) => {
    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", data.page);
    bodyData.append("on_page", data.on_page);
    bodyData.append("vacancy_id", data.vacancy);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies_candidates`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {});
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["vacancies_candidates"] !== -1) {
            this.applications = response["vacancies_candidates"];
          }
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      });
  };

  getVacancies_for_candidate = async (id) => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("candidate_id", id);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies_for_candidate`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.isLoading = false;
          this.error = true;
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["vacancies"] !== -1) {
            this.vacancies_for_candidate = response["vacancies"];
          } else {
            this.vacancies_for_candidate = [];
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };
}
